import { LogicNameFilter } from "../../../../../utils/constants";
import { searchObjectProperties } from "../../../../../utils/search";
import { getRiskNameFromValue } from "../../utils";
import { filterName } from "../utils";

export const applySharedFilters = (
  entities,
  appliedFilters,
  filterAndOrLogics,
  assets,
  fetchedFavoriteEntities,
  allCustomTags
) => {
  let filteredEntities = [...entities];

  // Search bar
  if (appliedFilters[filterName.SEARCH_STRING] !== "") {
    const lowerCaseSearchString =
      appliedFilters[filterName.SEARCH_STRING].toLowerCase();
    filteredEntities = filteredEntities.filter((entity) =>
      searchObjectProperties(entity, lowerCaseSearchString)
    );
  }

  // Risk
  if (Object.keys(appliedFilters[filterName.RISK]).length > 0) {
    const checkedRisks = Object.keys(appliedFilters[filterName.RISK]).filter(
      (key) => appliedFilters[filterName.RISK][key]
    );
    if (checkedRisks.length > 0) {
      filteredEntities = filteredEntities.filter((entity) =>
        checkedRisks.includes(getRiskNameFromValue(entity.risk))
      );
    }
  }

  // Sources
  if (Object.keys(appliedFilters[filterName.SOURCES]).length > 0) {
    const checkedSources = Object.keys(
      appliedFilters[filterName.SOURCES]
    ).filter((key) => appliedFilters[filterName.SOURCES][key] === true);
    if (checkedSources.length > 0) {
      if (filterAndOrLogics[filterName.SOURCES] === LogicNameFilter.LOGIC_OR) {
        filteredEntities = filteredEntities.filter(
          (entity) =>
            entity?.sources &&
            entity?.sources.some((source) => checkedSources.includes(source))
        );
      } else if (
        filterAndOrLogics[filterName.SOURCES] === LogicNameFilter.LOGIC_AND
      ) {
        filteredEntities = filteredEntities.filter(
          (entity) =>
            entity?.sources &&
            checkedSources.every((source) => {
              if (source !== "All") {
                return entity?.sources.includes(source);
              }
              return true;
            })
        );
      }
    }
  }

  // Exclude Source
  if (Object.keys(appliedFilters[filterName.EXCLUDE_SOURCE]).length > 0) {
    const checkedSources = Object.keys(
      appliedFilters[filterName.EXCLUDE_SOURCE]
    ).filter((key) => appliedFilters[filterName.EXCLUDE_SOURCE][key] === true);
    if (checkedSources.length > 0) {
      filteredEntities = filteredEntities.filter(
        (entity) =>
          !checkedSources.some((source) => entity?.sources.includes(source))
      );
    }
  }

  // My Favorites
  if (appliedFilters[filterName.MY_FAVORITES]) {
    filteredEntities = filteredEntities?.filter((entity) =>
      fetchedFavoriteEntities?.includes(entity.entity_id)
    );
  }

  // Related Assets
  if (Object.keys(appliedFilters[filterName.RELATED_ASSETS]).length > 0) {
    const checkedAssets = assets.filter((asset) =>
      Object.keys(appliedFilters[filterName.RELATED_ASSETS])
        .filter(
          (key) => appliedFilters[filterName.RELATED_ASSETS][key] === true
        )
        .includes(asset.asset_id)
    );
    if (checkedAssets.length > 0) {
      if (
        filterAndOrLogics[filterName.RELATED_ASSETS] ===
        LogicNameFilter.LOGIC_OR
      ) {
        filteredEntities = filteredEntities.filter((entity) =>
          checkedAssets?.some((asset) =>
            asset.entity_ids.includes(entity.entity_id)
          )
        );
      } else if (
        filterAndOrLogics[filterName.RELATED_ASSETS] ===
        LogicNameFilter.LOGIC_AND
      ) {
        filteredEntities = filteredEntities.filter((entity) =>
          checkedAssets.every((asset) =>
            asset.entity_ids.includes(entity.entity_id)
          )
        );
      }
    }
  }

  // CVE severity - Used for host and server entities
  if (
    filterName.CVE in appliedFilters &&
    Object.keys(appliedFilters[filterName.CVE]).length > 0
  ) {
    const checkedSeverities = Object.keys(
      appliedFilters[filterName.CVE]
    ).filter((key) => appliedFilters[filterName.CVE][key]);
    if (checkedSeverities.length > 0) {
      filteredEntities = filteredEntities.filter((entity) => {
        const entityCVESeverities = [];
        if (entity?.risk_breakdown?.vulns_critical)
          entityCVESeverities.push("Critical");
        if (entity?.risk_breakdown?.vulns_high)
          entityCVESeverities.push("High");
        if (entity?.risk_breakdown?.vulns_medium)
          entityCVESeverities.push("Medium");
        if (entity?.risk_breakdown?.vulns_low) {
          entityCVESeverities.push("Low");
        }
        return checkedSeverities.some((severity) =>
          entityCVESeverities.includes(severity)
        );
      });
    }
  }

  // Labels
  if (Object.keys(appliedFilters[filterName.LABELS]).length > 0) {
    const checkedLabels = Object.keys(appliedFilters[filterName.LABELS])
      .filter((key) => appliedFilters[filterName.LABELS][key] === true)
      .filter((key) => key !== "All");

    if (checkedLabels.length > 0) {
      if (filterAndOrLogics[filterName.LABELS] === LogicNameFilter.LOGIC_OR) {
        filteredEntities = filteredEntities.filter(
          (entity) =>
            entity?.labels &&
            entity?.labels.some((label) => checkedLabels.includes(label))
        );
      } else if (
        filterAndOrLogics[filterName.LABELS] === LogicNameFilter.LOGIC_AND
      ) {
        filteredEntities = filteredEntities.filter(
          (entity) =>
            entity?.labels &&
            checkedLabels.every((label) => entity?.labels.includes(label))
        );
      }
    }
  }
  // Custom Tags
  if (Object.keys(appliedFilters[filterName.CUSTOM_TAGS]).length > 0) {
    const checkedCustomTags = Object.keys(
      appliedFilters[filterName.CUSTOM_TAGS]
    )
      .filter((key) => appliedFilters[filterName.CUSTOM_TAGS][key] === true)
      .filter((key) => key !== "All");
    if (checkedCustomTags.length > 0) {
      if (
        filterAndOrLogics[filterName.CUSTOM_TAGS] === LogicNameFilter.LOGIC_OR
      ) {
        filteredEntities = filteredEntities.filter(
          (entity) =>
            entity?.custom_tags &&
            entity?.custom_tags?.some((tag) => checkedCustomTags.includes(tag))
        );
      } else if (
        filterAndOrLogics[filterName.CUSTOM_TAGS] === LogicNameFilter.LOGIC_AND
      ) {
        filteredEntities = filteredEntities.filter(
          (entity) =>
            entity?.custom_tags &&
            checkedCustomTags.every((tag) => entity?.custom_tags?.includes(tag))
        );
      }
    }
  }

  // Customer ID
  if (
    filterName.CUSTOMER_ID in appliedFilters &&
    Object.keys(appliedFilters[filterName.CUSTOMER_ID]).length > 0
  ) {
    const checkedCustomerIDs = Object.keys(
      appliedFilters[filterName.CUSTOMER_ID]
    )
      .filter((key) => appliedFilters[filterName.CUSTOMER_ID][key] === true)
      .filter((key) => key !== "All");
    if (checkedCustomerIDs.length > 0) {
      filteredEntities = filteredEntities.filter((entity) =>
        checkedCustomerIDs.includes(entity.customer_id)
      );
    }
  }

  if (
    filterName.ENTITY_IDS in appliedFilters &&
    Object.keys(appliedFilters[filterName.ENTITY_IDS]).length > 0
  ) {
    const checkedEntityIDs = Object.keys(
      appliedFilters[filterName.ENTITY_IDS]
    ).filter((key) => appliedFilters[filterName.ENTITY_IDS][key]);
    if (checkedEntityIDs.length > 0) {
      filteredEntities = filteredEntities.filter((entity) =>
        checkedEntityIDs.includes(entity.entity_id + "-" + entity.customer_id)
      );
    }
  }

  entities.length = 0;
  for (let i = 0; i < filteredEntities.length; i++) {
    entities[i] = filteredEntities[i];
  }
};
